











import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'modal-workboard',
    components: {

    },
    props: {
        maxWidth: Number,
        marginTop: Number
    },
    data() {
        return {
            style: style
        }
    },
    computed:{
        getStyle(){
            if (this.marginTop != null){
                return `max-width:${this.maxWidth}px; margin-top:${this.marginTop}px;`
            }
            return `max-width:${this.maxWidth}px`;
        }
    }
})
